import { render } from "./WorkbookCard.vue?vue&type=template&id=64232b9c"
import script from "./WorkbookCard.vue?vue&type=script&lang=js"
export * from "./WorkbookCard.vue?vue&type=script&lang=js"

import "./WorkbookCard.vue?vue&type=style&index=0&id=64232b9c&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__